import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  .text-spinner {
    height: 20px;
  }
`;
